import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import { Slider } from "../ui/slider";
import { Users } from "lucide-react";

export function OwnerOptionsSection({
  guaranteedReturnPct,
  setGuaranteedReturnPct,
  readOnly = false,
}) {
  return (
    <Card className="shadow-md">
      <CardHeader className="p-4 sm:p-6">
        <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
          <Users className="h-4 w-4 sm:h-5 sm:w-5 text-primary flex-shrink-0" />
          Owner Options
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 sm:p-6 pt-0">
        <div className="space-y-3">
          <Label htmlFor="guaranteed-return-pct" className="text-xs sm:text-sm">
            Guaranteed Owner Return (% of Present Value)
          </Label>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
            <Slider
              id="guaranteed-return-pct"
              min={0}
              max={50}
              step={1}
              value={[guaranteedReturnPct]}
              onValueChange={(value) => setGuaranteedReturnPct(value[0])}
              className="flex-1"
              disabled={readOnly}
            />
            <span className="text-sm sm:text-base font-semibold text-gray-700 sm:min-w-[140px] text-left sm:text-right">
              {guaranteedReturnPct}% of PV
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
